import ShiftDeclinedReason from "@/models/Shared/ShiftDeclinedReason";
import ShiftDto from "@/models/Shifts/ShiftDto";

export default class BookingOfferShiftViewModel {
    bookingRoleWorkerShiftId = '';
	shift: ShiftDto = new ShiftDto();
	applied = false;
	declinedReason: ShiftDeclinedReason;
}